var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_3317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8168 113.826H89.7341C87.5019 113.826 85.6917 112.016 85.6917 109.784C85.6917 107.552 87.5019 105.741 89.7341 105.741H98.8168C102.19 105.741 104.935 102.997 104.935 99.6234V15.0289C104.935 11.656 102.191 8.91105 98.8168 8.91105H14.2223C10.8493 8.91105 8.10441 11.655 8.10441 15.0289V99.6234C8.10441 102.996 10.8483 105.741 14.2223 105.741H62.6488C64.881 105.741 66.6912 107.552 66.6912 109.784C66.6912 112.016 64.881 113.826 62.6488 113.826H14.2223C6.39081 113.826 0.0195312 107.455 0.0195312 99.6234V15.0289C0.0195312 7.19745 6.39081 0.826172 14.2223 0.826172H98.8168C106.648 0.826172 113.02 7.19745 113.02 15.0289V99.6234C113.02 107.455 106.648 113.826 98.8168 113.826Z",
    fill: "url(#paint0_linear_727_3317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6488 113.826H14.2223C6.39081 113.826 0.0195312 107.455 0.0195312 99.6234V51.1969C0.0195312 43.3654 6.39081 36.9941 14.2223 36.9941H39.2401C41.4723 36.9941 43.2825 38.8044 43.2825 41.0366C43.2825 43.2688 41.4723 45.079 39.2401 45.079H14.2223C10.8493 45.079 8.10441 47.8239 8.10441 51.1969V99.6234C8.10441 102.996 10.8483 105.741 14.2223 105.741H62.6488C66.0217 105.741 68.7667 102.997 68.7667 99.6234V75.4101C68.7667 73.1779 70.5769 71.3677 72.8091 71.3677C75.0413 71.3677 76.8515 73.1779 76.8515 75.4101V99.6234C76.8515 107.455 70.4803 113.826 62.6488 113.826Z",
    fill: "url(#paint1_linear_727_3317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1184 53.7682C63.0841 53.7682 62.0488 53.3738 61.2601 52.5841C59.6815 51.0056 59.6815 48.446 61.2601 46.8675L83.0804 25.0472C84.6589 23.4687 87.2184 23.4687 88.797 25.0472C90.3755 26.6257 90.3755 29.1853 88.797 30.7638L66.9767 52.5841C66.1869 53.3738 65.1526 53.7682 64.1184 53.7682Z",
    fill: "url(#paint2_linear_727_3317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9385 50.3422C83.7063 50.3422 81.896 48.532 81.896 46.2998V31.9491H67.5454C65.3132 31.9491 63.5029 30.1389 63.5029 27.9067C63.5029 25.6745 65.3132 23.8643 67.5454 23.8643H85.9385C88.1707 23.8643 89.9809 25.6745 89.9809 27.9067V46.2998C89.9809 48.532 88.1707 50.3422 85.9385 50.3422Z",
    fill: "url(#paint3_linear_727_3317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0988 90.7882C26.0646 90.7882 25.0303 90.3939 24.2405 89.6041C22.662 88.0256 22.662 85.466 24.2405 83.8875L46.0608 62.0672C47.6394 60.4887 50.1989 60.4887 51.7774 62.0672C53.356 63.6457 53.356 66.2053 51.7774 67.7838L29.9571 89.6041C29.1684 90.3929 28.1331 90.7882 27.0988 90.7882Z",
    fill: "url(#paint4_linear_727_3317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4932 90.788H27.1001C24.8678 90.788 23.0576 88.9778 23.0576 86.7456V68.3525C23.0576 66.1203 24.8678 64.3101 27.1001 64.3101C29.3323 64.3101 31.1425 66.1203 31.1425 68.3525V82.7032H45.4932C47.7254 82.7032 49.5356 84.5134 49.5356 86.7456C49.5356 88.9778 47.7254 90.788 45.4932 90.788Z",
    fill: "url(#paint5_linear_727_3317)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_3317",
    x1: 56.5195,
    y1: 0.826172,
    x2: 56.5195,
    y2: 113.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_727_3317",
    x1: 38.4355,
    y1: 36.9941,
    x2: 38.4355,
    y2: 113.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_727_3317",
    x1: 75.0285,
    y1: 23.8633,
    x2: 75.0285,
    y2: 53.7682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_727_3317",
    x1: 76.7419,
    y1: 23.8643,
    x2: 76.7419,
    y2: 50.3422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_727_3317",
    x1: 38.009,
    y1: 60.8833,
    x2: 38.009,
    y2: 90.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_727_3317",
    x1: 36.2966,
    y1: 64.3101,
    x2: 36.2966,
    y2: 90.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_3317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    fill: "white",
    transform: "translate(0.0195312 0.826172)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.38737167e719c3d7d4dce009bc507a7a.svg";
export { ForwardRef as ReactComponent };